export default __webpack_public_path__ + "static/media/reflection.edb2056d.mp3";